import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { useGetUser } from '~modules/user/api/hooks/use-get-user';

import { ROUTES } from '~app/router/routes';

export const AdminPrivateRoute = () => {
  const location = useLocation();
  const { data: user, isLoading, isFetching } = useGetUser();

  if (isLoading || isFetching) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'fog.95',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user?.is_admin) {
    return (
      <Navigate
        to={ROUTES.DASHBOARD}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <Outlet />;
};
